// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__bDm0b","errorLogs":"styles_errorLogs__35kWu"};